import { FC, Fragment } from 'react';
import { ICultureListItem } from '../../slice/types';
import CulturesTable from '../CulturesTable/CulturesTable';

import * as S from './CompaniesCulturesTables.styles';

interface IProps {
  companies: {
    cultures: ICultureListItem[];
    id: number;
    name: string;
  }[];
}

const CompaniesCulturesTables: FC<IProps> = ({ companies }) => {
  return (
    <>
      {companies.map(company => {
        const totalArea = company.cultures.reduce((prevItem, nextItem) => {
          return (prevItem += nextItem.area);
        }, 0);

        return (
          <S.StyledCard key={company.id}>
            <S.TableTitle>{company.name}</S.TableTitle>

            <CulturesTable
              culturesArr={company.cultures}
              totalArea={totalArea}
              companyId={company.id}
            />
          </S.StyledCard>
        );
      })}
    </>
  );
};

export default CompaniesCulturesTables;
